<template>
  <div class="certificate-container">
      <div class="titleBox">
        <div class="titleLeft">
          <img
            src="../../assets/images/titleArrow.png"
            alt=""
            @click="returnTopic()"
          />
        </div>
        <div class="titleCentre">学分详情</div>
        <div class="titleRight"></div>
    </div>
    <!-- 学分进度卡片 -->
    <div v-if="progressInfo"class="progress-card">
      <!-- <div class="progress-title">学分进度</div> -->
      <div class="progress-row">
        <div class="score-block">
          
          <div class="score">{{ progressInfo.fileUrl ? (progressInfo.earnedScore ? progressInfo.earnedScore:0 ):  progressInfo.courseScore}}</div>
          <div class="desc">我的学分</div>
        </div>
        <!-- <div class="score-block right">
          <div class="score">{{ progressInfo.minimumScore }}</div>
          <div class="desc">所需学分</div>
        </div> -->
      </div>
      <div v-if="progressInfo.fileUrl" class="progress-bar-wrap">
        <div class="progress-bar-bg">
          <div class="progress-bar" :style="{ width: (progressInfo.earnedScore/progressInfo.minimumScore)*100 + '%' }"></div>
          <div class="progress-dot" :style="{ left: (progressInfo.earnedScore/progressInfo.minimumScore)*100 + '%' }">
            <div class="progress-bubble">{{ (progressInfo.earnedScore/progressInfo.minimumScore)*100 }}%</div>
          </div>
        </div>
        <div class="progress-tip">
          <template v-if="(progressInfo.minimumScore - progressInfo.earnedScore)>0">
             还需 <span class="highlight">{{ progressInfo.minimumScore - progressInfo.earnedScore }}学分</span> 即可获得证书
          </template>
          <template v-else>
            已到达可获得证书标准

          </template>
         
        </div>
      </div>
    </div>

    <!-- 教学资源 -->
    <div  v-if="progressInfo&&progressInfo.fileUrl" class="resource-section">
      <div class="resource-title">我的证书</div>
      <div class="certificate-preview">
        <div ref="preview" class="preview-inner">
          <!-- ${this.imgUrl} -->
          <img ref="img1" :src="`${this.imgUrl}${ progressInfo.fileUrl }`" crossorigin="anonymous"/>
          <span>{{ progressInfo.realName }}</span>
           <span class="courseTimeStyle">{{ progressInfo.courseTime }}</span>
        </div>
        <!-- <div
          class="preview-placeholder"
          @click="onCreateCanvas"
        >
          点击预览证书
        </div> -->
      </div>
      <div v-if="progressInfo&&progressInfo.fileUrl" class="btn-group">
        
        <!-- isPass 是否达标: 0->否，1->是-->
         <!-- v-if="!progressInfo.isCollect"  -->
        <button v-if="!progressInfo.isCollect" @click="getCollect( progressInfo)" class="get-btn">领取证书</button>
        <button v-else class="download-btn"  @click="onCreateCanvas">下载证书</button>
      </div>
    </div>

    <!-- 关联课程 -->
    <div  v-if="progressInfo&&progressInfo.onlineCourseList" class="related-section">
      <div class="related-title">关联课程</div>
      <ul class="related-list">
        <li v-for="item in progressInfo.onlineCourseList" :key="item">{{ item.onlineCourseName }}</li>
      </ul>
    </div>
    <canvas v-show="false" ref="myCanvas" id="myCanvas"></canvas>
    <el-dialog :visible.sync="previewDialogVisible" width="360px" :show-close="true" :before-close="previewDialogBefore" center>
        <!-- <div ref="preview" class="preview-inner">
          <img ref="img1" :src="`${this.imgUrl}${ progressInfo.fileUrl}`" crossorigin="anonymous"/>
          <span>{{ name }}</span>
        </div> -->
        <div class="canvasPhoto">
          <div ref="photo" class="photo"></div>
          <!-- <el-button v-if="!isWeChatBrowser" type="primary" @click="downloadCanvasImage">下载图片</el-button> -->
          <p >长按下载图片</p>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import { progress, collect } from "@/api/teach/courseList"
import { judgeClient, isWeChatBrowser, closeIos, closeAndroid } from '@/utils/index.js';
import { base64 } from "js-md5";

export default {
  name: 'Certificate',
  data() {
    return {
      progressInfo:null,
      currentScore: 80,
      progress: 80,
      previewDialogVisible: false,
      previewImg: '',
      name:"王小明",
      isWeChatBrowser:false,
      base64Url:null,
    };
  },
  created(){
    this.getProgress(this.$route.query.onlineCourseId);
    this.isWeChatBrowser = isWeChatBrowser();

  },
  methods:{
    returnTopic() {
      this.$router.push({
        path: "/teachLearn",
        // query: { studyBankId: this.studyBankId },
      });
    },
    getCollect( row ){
      if( !row.isPass ){
        this.$message({
          showClose: true,
          message: '学分还没有达到，暂时不可以领取',
          type: 'warning'
        });
        return;

      }

      collect({onlineCourseCertificateCode:row.onlineCourseCertificateCode}).then( res => {
        if( res.data ){
           this.getProgress(this.$route.query.onlineCourseId)
           this.$message({
            showClose: true,
            message: '领取成功',
            type: 'success'
          });
        }

      })
    },
    getProgress( onlineCourseId ){
      progress( {onlineCourseId } ).then( res => {
        // res.data.fileUrl = "https://file.medmeta.com/web/weixin/zhengshu.png";
        res.data.fileUrl = res.data.fileUrl ? res.data.fileUrl:false;
        this.progressInfo = res?.data;
      })
    },
    previewDialogBefore(){
      document.getElementById("canvasImg").remove();
      this.previewDialogVisible = false;
    },
    onCreateCanvas() {
      let img1 = this.$refs.img1;
      img1.crossOrigin = "anonymous"; // 保险起见，js里也加一遍
      // console.log(img1.naturalWidth, img1.naturalHeight) 可获取图片的原始宽度和高度
      let canvasWidth = img1.naturalWidth// 这里设置固定值
      let canvasHeight = img1.naturalHeight // 合成的画布高度为两张图片高度之和
      let canvas = this.$refs.myCanvas;
      let context = canvas.getContext('2d');
      canvas.width = canvasWidth // canvas画布宽度
      canvas.height = canvasHeight // canvas画布高度
      // 将img1、img2等依次加入画布
      context.drawImage(img1, 0, 0, canvasWidth, canvasHeight)  // 加入图片1
      context.fillStyle = 'red' // 设置文字的填充颜色
      context.font = 'italic 20px Georgia' // 设置文字的填充样式
      context.fillText(this.progressInfo.realName, 60, 20) // 在画布中添加文字
       context.fillText(this.progressInfo.courseTime, 60, 60) // 在画布中添加文字
      let newImg = new Image(canvasWidth*0.5,canvasHeight*0.5)
      newImg.src = canvas.toDataURL('image/png') // canvas画布导出图片
      newImg.id = "canvasImg";
      // if( this.isWeChatBrowser ){
        this.previewDialogVisible = true;
        setTimeout(() => {
          this.$refs.photo.append(newImg);
        },0);
      // }else{
      //    this.base64Url = canvas.toDataURL('image/png');
      //    this.downloadCanvasImage()

      // }
      
    },
    opneFileAndroid( url ){
      this.$bridge.callmethod(
        "WebAction.saveBase64Pic2Local",
        `${ url }`,
        (res) => {
        }
      );
    },
    opneFileIos( url ){
       try {
        //使用此方法,会报错,因此使用try-catch
        webkit.messageHandlers.saveBase64Pic2Local.postMessage(
           `${ url.split(",")[1] }`,
          (data) => {}
        );
        
      } catch (error) {
        console.log("WKWebView post message error: ", error);
      }

    },
    downloadCanvasImage( url ) {
      if (judgeClient() == "Android") {
        this.opneFileAndroid(  this.base64Url );
      } else {
        this.opneFileIos(  this.base64Url );
      }
      return;
      let a = document.createElement('a');
      console.log("***************", url)
      a.href = url;
      a.download = 'certificate.png'; // 下载的文件名
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
  }
};
</script>

<style scoped lang="scss">
.certificate-container {
  background: #fff;
  min-height: 100vh;
  .photo{
    overflow: scroll;
    
  }
  .titleBox {
    padding:0px 16px 0 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 46px;
    .titleLeft {
      width: 20px;
      height: 20px;
      img {
        width: 20px;
        height: 20px;
      }
    }
    .titleCentre {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 17px;
      color: #121212;
      text-align: left;
      font-style: normal;
    }
    .titleRight {
    }
  }
  .canvasPhoto{
    display: flex;
    flex-direction: column;
    align-items: center;
    img{
      margin-bottom:16px;
    }
    p{
      color: #ff9900;
    }
  }
  .preview-inner {
    width: 311px;
    min-height: 150px;
    background: #EDEDEF;
    border-radius: 4px;
    margin-bottom: 8px;
    position: relative;
    img {
      width:100%;
    }
    span {
      position: absolute;
      top:60px;
      left:20px;
      display: inline-block;
    }
    .courseTimeStyle{
      top:100px;
      left:20px;

    }
  }
  .progress-card {
    width:343px;
    height: 176px;
    background: url('../../assets/images/progressBackImg.png') no-repeat center/cover;
    border-radius: 8px;
    padding: 22px 18px 24px 18px;
    margin: 0 16px 22px 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .progress-title {
      font-size: 17px;
      font-weight: 500;
      color: #222;
      margin-bottom: 12px;
      text-align: left;
      width: 100%;
    }
    .progress-row {
      display: flex;
      justify-content: center;
      align-items: flex-end;
      width: 100%;
      margin-bottom: 20px;
      .score-block {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 60px;
        &.right {
          align-items: flex-end;
        }
        .score {
          font-size: 26px;
          color: #121212;
          font-weight: bold;
        }
        .desc {
          font-size: 13px;
          color: #888;
          margin-top: 2px;
        }
      }
    }
    .progress-bar-wrap {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      .progress-bar-bg {
        width: 90%;
        max-width: 260px;
        height: 10px;
        background: #e3edfa;
        border-radius: 8px;
        position: relative;
        margin: 0 auto 8px auto;
        .progress-bar {
          height: 10px;
          background: linear-gradient(90deg, #4d9fff 0%, #256bfa 100%);
          border-radius: 8px;
          position: absolute;
          left: 0;
          top: 0;
        }
        .progress-dot {
          position: absolute;
          top: 50%;
          transform: translate(-50%, -50%);
          z-index: 2;
          .progress-bubble {
            min-width: 44px;
            height: 28px;
            background: #fff;
            border-radius: 16px;
            box-shadow: 0 2px 8px 0 rgba(37,107,250,0.10);
            display: flex;
            align-items: center;
            justify-content: center;
            color: #256bfa;
            font-size: 15px;
            font-weight: 500;
            border: 1.5px solid #e3edfa;
            position: absolute;
            top: -38px;
            left: 50%;
            transform: translate(-50%, 0);
          }
        }
      }
      .progress-tip {
        font-size: 15px;
        color: #888;
        margin-top: 2px;
        text-align: center;
        .highlight {
          color: #ff9900;
          font-weight: 500;
        }
      }
    }
  }
  .resource-section {
    background: #fff;
    border-radius: 12px;
    margin: 0 16px 22px 16px;
    .resource-title {
      font-size: 16px;
      font-weight: 500;
      color: #222;
      margin-bottom: 10px;
      padding-left:16px;
    }
    .certificate-preview {
      // background: #F8F8FA;
      border-radius: 8px;
      border: 1.5px dashed #e0e0e0;
      box-sizing: border-box;
      padding: 12px 8px 0 8px;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 10px;

      .preview-placeholder {
        color: #bbb;
        font-size: 15px;
        text-align: center;
        width: 100%;
        margin-bottom: 8px;
        letter-spacing: 1px;
      }
    }
    .btn-group {
      display: flex;
      justify-content: center;
      gap: 18px;
      margin-bottom: 4px;
      .download-btn {
        border-radius: 22px;
        padding: 8px 28px;
        font-size: 15px;
        background: #fff;
        color: #256bfa;
        border: 1.5px solid #e3edfa;
        box-shadow: 0 2px 8px 0 rgba(37,107,250,0.04);
        outline: none;
        cursor: pointer;
        transition: box-shadow 0.2s;
        &:active {
          box-shadow: 0 1px 4px 0 rgba(37,107,250,0.10);
        }
      }
      .get-btn {
        border-radius: 22px;
        padding: 8px 28px;
        font-size: 15px;
        background: linear-gradient(90deg, #4d9fff 0%, #256bfa 100%);
        color: #fff;
        border: none;
        box-shadow: 0 4px 16px 0 rgba(37,107,250,0.15);
        outline: none;
        cursor: pointer;
        font-weight: 500;
        transition: box-shadow 0.2s;
        &:active {
          box-shadow: 0 2px 8px 0 rgba(37,107,250,0.10);
        }
      }
    }
  }
  .related-section {
    margin: 0 16px;
    .related-title {
      font-size: 16px;
      font-weight: 500;
      color: #222;
      margin-bottom: 10px;
    }
    .related-list {
      list-style: none;
      padding: 0;
      margin: 0;
      li {
        font-size: 15px;
        color: #333;
        padding: 12px 0 12px 0;
        border-bottom: 1.5px solid #f0f0f0;
        &:last-child {
          border-bottom: none;
        }
      }
    }
  }
}
</style> 